import { observer } from 'mobx-react-lite'
import { StyleSheet, Text, View } from 'react-native'

import { Pot } from '@ppwr/poker'

import { fontFamily } from '../../../../../theme'
import ChipsIcon from '../../../assets/Chips.svg'
import { PlayerAvatar } from '../../../PlayerAvatar'

export const SidePot = observer(({ pot }: { pot: Pot }) => {
  const { players, amount } = pot

  return (
    <View style={styles.container}>
      <View style={styles.playersContainer}>
        {players.map((player, i) => (
          <PlayerAvatar
            key={`$player-avatar-${player.id}-${i}`}
            name={player.name}
            color={player.color}
            invert
            size={3}
          />
        ))}
      </View>
      <View style={styles.amountContainer}>
        <ChipsIcon />
        <Text style={styles.text}>{amount.toLocaleString()}</Text>
      </View>
    </View>
  )
})

const styles = StyleSheet.create({
  container: {
    borderColor: 'lightgray',
    borderWidth: 1,
    borderRadius: 4,
    height: 80,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingHorizontal: 20
  },
  playersContainer: {
    display: 'flex',
    flexDirection: 'row',
    gap: -13
  },
  amountContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 5
  },
  text: {
    fontWeight: 'bold',
    fontFamily: fontFamily.GTAmericaStandardMedium
  }
})
